import React from 'react';
import { bool, string } from 'prop-types';
import styled from 'styled-components';

import Box from 'ravenjs/lib/Box';

const YouTubeFrameStyled = styled(Box)`
    height: ${({ height }) => height};
    width: ${({ width }) => width};
`;

function YouTubeFrame({ autoplay, height, title, videoId, width }) {
    return (
        <YouTubeFrameStyled height={height} width={width}>
            <iframe
                id="player"
                width="100%"
                height="100%"
                src={`https://www.youtube.com/embed/${videoId}?autoplay=${autoplay ? 1 : 0}`}
                allow="autoplay"
                frameBorder="0"
                title={title}
            />
        </YouTubeFrameStyled>
    );
}

YouTubeFrame.propTypes = {
    /**
     * TO play video on load
     */
    autoplay: bool,
    /**
     * Height of the player
     */
    height: string,
    /**
     * Video title
     */
    title: string.isRequired,
    /**
     * Youtube video Id
     */
    videoId: string.isRequired,
    /**
     * Width of the player
     */
    width: string,
};

YouTubeFrame.defaultProps = {
    autoplay: false,
    height: '400px',
    width: '640px',
};

export default YouTubeFrame;
